import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { PURCHASE_ANCHOR, insideImages } from '../data/content';
export function LookInside() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [index, setIndex] = useState(0);
  const scrollTo = useCallback((i: number) => {
    const track = trackRef.current;
    if (!track) return;
    const clamped = Math.max(0, Math.min(insideImages.length - 1, i));
    track.scrollTo({
      left: clamped * track.clientWidth,
      behavior: 'smooth'
    });
    setIndex(clamped);
  }, []);
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      setIndex(Math.max(0, Math.min(insideImages.length - 1, i)));
    };
    track.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => track.removeEventListener('scroll', onScroll);
  }, []);
  return <section className="bg-white px-3 py-4 sm:px-6" data-id="element-86" data-mp="a2o3oog3rxft">
      <div className="mx-auto max-w-2xl" data-id="element-87" data-mp="a1394ytsgehy">
        <h2 className="text-center text-xl font-extrabold uppercase text-navy sm:text-3xl" data-id="element-88" data-mp="612v3falq5bf">
          Look inside
        </h2>
        <p className="mt-0.5 text-center font-heading text-xs font-semibold uppercase tracking-wide text-mid sm:text-sm" data-id="element-89" data-mp="k13wcvus3erf">
          Discover What's Inside NEUROLOGY VISUAL ATLAS™
        </p>
        <p className="mt-1 text-center text-sm leading-snug sm:text-base" data-id="element-90" data-mp="3nh1a1es5f4ui">
          Neuroanatomy, functional maps, neural pathways, lesion localization,
          cranial nerves, brainstem relationships, neurological signs, clinical
          patterns, major disorders, neurological assessment and structured
          clinical reasoning.
        </p>

        <div className="relative mt-2" data-id="element-91" data-mp="3sfcf7c7i0r6e">
          <div ref={trackRef} className="no-scrollbar flex snap-x snap-mandatory overflow-x-auto rounded-md border border-navy/10 bg-navy" role="group" aria-roledescription="carousel" aria-label="Interior pages of Neurology Visual Atlas" tabIndex={0} data-id="element-92" data-mp="34qjihdj1yfaq">
            {insideImages.map((img, i) => <a key={img.src} href={PURCHASE_ANCHOR} className="w-full shrink-0 snap-center p-1.5" aria-label={`Page ${i + 1} of ${insideImages.length} — get the complete system`} data-id="element-93" data-mp="1den0uv16pmee" data-mpi={i}>
                <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} className="mx-auto w-full rounded-sm bg-white shadow-md" data-id="element-94" data-mp="krk7sifa23vj" />
              </a>)}
          </div>

          <button type="button" onClick={() => scrollTo(index - 1)} disabled={index === 0} aria-label="Previous page" className="absolute left-1 top-1/2 -translate-y-1/2 rounded-full bg-electric p-1.5 text-navy shadow-md transition-[filter,opacity] duration-150 ease-out hover:brightness-110 disabled:opacity-30" data-id="element-95" data-mp="yqtpxnn1n825">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="2f9hqb8fn9to2" />
          </button>
          <button type="button" onClick={() => scrollTo(index + 1)} disabled={index === insideImages.length - 1} aria-label="Next page" className="absolute right-1 top-1/2 -translate-y-1/2 rounded-full bg-electric p-1.5 text-navy shadow-md transition-[filter,opacity] duration-150 ease-out hover:brightness-110 disabled:opacity-30" data-id="element-97" data-mp="2aij5bvjpo7eh">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-98" data-mp="1rjezswrdovrk" />
          </button>
        </div>

        <div className="mt-1.5 flex items-center justify-center gap-1.5" data-id="element-99" data-mp="1njda7lyx3ssn">
          {insideImages.map((img, i) => <button key={img.src} type="button" onClick={() => scrollTo(i)} aria-label={`Go to page ${i + 1}`} aria-current={i === index} className={`h-1.5 rounded-full transition-[width,background-color] duration-150 ease-out ${i === index ? 'w-5 bg-electric' : 'w-1.5 bg-navy/25'}`} data-id="element-100" data-mp="3lwwsey6n4itg" data-mpi={i} />)}
        </div>
      </div>
    </section>;
}